import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzButtonModule } from 'ant-reset-private/button';
import { NzAddOnModule, NzNoAnimationModule, NzOverlayModule } from 'ant-reset-private/core';
import { NzIconModule } from 'ant-reset-private/icon';
import { NzMenuModule } from 'ant-reset-private/menu';

import { NzDropDownADirective } from './nz-dropdown-a.directive';
import { NzDropDownButtonComponent } from './nz-dropdown-button.component';
import { NzDropdownContextComponent } from './nz-dropdown-context.component';
import { NzDropDownComponent } from './nz-dropdown.component';
import { NzDropDownDirective } from './nz-dropdown.directive';

import { NzDropdownService } from './nz-dropdown.service';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    FormsModule,
    NzButtonModule,
    NzMenuModule,
    NzIconModule,
    NzNoAnimationModule,
    NzOverlayModule,
    NzAddOnModule
  ],
  entryComponents: [NzDropdownContextComponent],
  declarations: [
    NzDropDownComponent,
    NzDropDownButtonComponent,
    NzDropDownDirective,
    NzDropDownADirective,
    NzDropdownContextComponent
  ],
  exports: [NzMenuModule, NzDropDownComponent, NzDropDownButtonComponent, NzDropDownDirective, NzDropDownADirective],
  providers: [NzDropdownService]
})
export class NzDropDownModule {}
